var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-left"},[_c('v-card',{staticStyle:{"background-color":"#eaeaea"}},[_c('v-card-title',[_vm._v(" "+_vm._s(_vm.role)+" ")]),_c('v-card-text',[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }